<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Cargos</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <RoleList />
    </v-card-text>
  </v-card>
</template>

<script>
import RoleList from './components/RoleList.vue'
export default {
  name: 'RoleAdmin',
  components: {
    RoleList,
  },
  data: function () {
    return {
      dialog: false,
    }
  },
  computed: {},
  methods: {},
}
</script>
